export const GET_NOURRITURE_SUCCESS = "GET_NOURRITURE_SUCCESS";
export const GET_NOURRITURE_LOAD = "GET_NOURRITURE_LOAD";
export const GET_NOURRITURE_FAILD = "GET_NOURRITURE_FAILD";
